// src/components/GoogleLoginButton.js
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SupaBaseAuth from "./SupaBaseAuth";
import { useTranslation } from "react-i18next";

function GoogleLoginButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // Récupérer la route d'origine (par défaut "/")
  const from = location.state?.from?.pathname || "/";
  const handleLogin = async () => {
    try {
      const successMessage = await SupaBaseAuth.loginWithGoogle();

      // Rediriger l'utilisateur ou gérer l'état après la connexion ici
      navigate(from);
    } catch (error) {
      console.error("Erreur de connexion Google:", error);
    }
  };

  return (
    <div>
      <button
        onClick={handleLogin}
        className="w-full flex items-center justify-center border border-gray-600 rounded-full py-2 px-4 hover:bg-gray-800 transition"
      >
        <img
          src="https://img.icons8.com/color/16/000000/google-logo.png"
          alt="Google logo"
          className="mr-2"
          loading="lazy"
        />
        {t("auth.connectWithGoogle")}
      </button>
    </div>
  );
}

export default GoogleLoginButton;
